'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reduxPagan = require('redux-pagan');
var _reactRedux = require('react-redux');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _PrivacyPolicyPage = require('../PrivacyPolicyPage/PrivacyPolicyPage.scss');var styles = _interopRequireWildcard(_PrivacyPolicyPage);
var _HelpPage = require('./HelpPage.scss');var helpStyles = _interopRequireWildcard(_HelpPage);

var _questions = require('./questions.json');var _questions2 = _interopRequireDefault(_questions);

var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
// Helpers
var HelpList = function (_AnchorList) {_inherits(HelpList, _AnchorList);function HelpList() {var _temp, _this, _ret;_classCallCheck(this, HelpList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _AnchorList.call.apply(_AnchorList, [this].concat(args))), _this), _this.localRequire = __CLIENT__ && {
      en: require.context('../../translations/help/en/'),
      ru: require.context('../../translations/help/ru/'),
      he: require.context('../../translations/help/he/') }, _temp), _possibleConstructorReturn(_this, _ret);}return HelpList;}(_components.AnchorList);var



HelpPage = function (_Component) {_inherits(HelpPage, _Component);function HelpPage() {var _temp2, _this2, _ret2;_classCallCheck(this, HelpPage);for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this2), _this2.
    handleOpen = function (idx) {
      var containerClasses = _this2['question-' + idx].classList;
      if (containerClasses.contains('opened')) {
        containerClasses.remove('opened');
        setTimeout(function () {return containerClasses.remove('transition');}, 200);
      } else {
        containerClasses.add('opened');
        containerClasses.add('transition');
      }
    }, _this2.

    renderHelmet = function () {var _this2$props =
      _this2.props,route = _this2$props.route,locale = _this2$props.locale;
      var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);
      return (
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: _this2.props.staticTranslates('title', 'titleTemplate')(),
          title: _this2.props.staticTranslates('helmet', 'helpTitle')(),
          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route },
          { property: 'og:title', content: _this2.props.staticTranslates('helmet', 'helpTitle') + ' | \u202BOnMap' },
          { property: 'og:description', content: _this2.props.staticTranslates('helmet', 'helpDescription') },
          { name: 'description', content: _this2.props.staticTranslates('helmet', 'helpDescription') }],

          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }));



    }, _temp2), _possibleConstructorReturn(_this2, _ret2);}HelpPage.prototype.

  render = function render() {var _cx;
    // const { locale } = this.props;
    var locale = 'he';

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.main_block, helpStyles.page, (_cx = {}, _cx[helpStyles.mobile] = this.props.isMobile, _cx), 'rtl') },
        _react2.default.createElement('div', { className: styles.content },
          this.renderHelmet(),
          _react2.default.createElement('div', { style: { marginTop: '95px' } },

            !this.props.isMobile && !this.props.isNative &&
            _react2.default.createElement(_components.OMTitle, { className: 'pageTitle', title: this.props.staticTranslates('footer', 'help') }),


            _react2.default.createElement(HelpList, { dataList: _questions2.default, locale: locale, listComponentClassName: helpStyles.accordion })))));




  };return HelpPage;}(_react.Component);


HelpPage.propTypes = {
  staticTranslates: _propTypes2.default.func.isRequired,
  route: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'terms'),
    locale: state.lang.locale,
    staticTranslates: (0, _reduxPagan.getLang)(state.lang, 'static') };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
HelpPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/HelpPage/HelpPage.js
// module id = 3059
// module chunks = 0